/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Col, Form, Input, InputNumber, message, Modal, Row, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { PhoneNumberFormItem } from '~/components';
import Button from '~/components/Button';
import FloatLabel from '~/components/Form/FloatLabel';
import FormDrawer from '~/components/FormDrawer';
import Checkbox from '~/components/inputs/Checkbox';
import CustomTooltip from '~/components/OpenedToolTip';
import { useSendInvitaion, useUpdateCardholder } from '~/controllers/cardholder';
import CardHolderDetails from '~/pages/cardholder/details';
import { setEditedNodeDetails, setNodeDetails, setOpencarholdereditModal } from '~/slices/state';
import emailDuplicateCheck from '~/utils/emailValidation';
import { isSales } from '~/utils/getDecodedJwt';
import phoneValidation from '~/utils/phoneValidation';
import { capitalizeWords } from '~/utils/validateCharacters';

function CardHolderEditModal(props: any) {
  const [isSASloading, setIsSASloading] = useState(false);
  const [isSendInvitationBtnLoadin, setIsSendInvitationBtnLoadin] = useState(false);

  const { isModalOpen, allProductsLists, productKey } = props;
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const sales = isSales();
  const cardholderInitialValues = useSelector((state: any) =>
    sales ? state.state?.nodeDetails : state.state?.nodeDetails?.cardHolderValues,
  );
  const formName = sales ? 'addCardholder' : '/cardHolder/details';
  const cardKey = useSelector((state: any) => state.state?.nodeDetails?.key);
  const dispatch = useDispatch();
  const updateCardHolder = useUpdateCardholder();
  const sendInvitaion = useSendInvitaion();
  const isItPhysical = !!cardholderInitialValues?.email;

  const onClose = () => {
    dispatch(setOpencarholdereditModal<any>(false));
    dispatch(setNodeDetails<any>({}));
  };
  const open = isModalOpen;

  async function saveHandler(value?: any) {
    setIsSASloading(true);

    const editedObj = value || form.getFieldsValue();

    const finalObj = sales ? editedObj : { ...cardholderInitialValues, ...editedObj };
    const cardholderName = isItPhysical
      ? `${editedObj.firstName.trim()} ${editedObj.lastName.trim()}`
      : editedObj.nameOfVirtualCardAccount.trim();
    const allProducts = Object.values(allProductsLists || {})?.flat();
    const checkIfNameIsUnique = allProducts?.find(
      (item: any) =>
        item?.name.toLowerCase() === cardholderName.toLowerCase() &&
        item.type === 'cardholder' &&
        item.key !== cardKey &&
        item?.contactId !== editedObj?.contactId,
    );
    if (checkIfNameIsUnique) {
      return message.error('Cardholder name should be unique overall the products');
    }
    if (isItPhysical) {
      try {
        await updateCardHolder.mutateAsync(finalObj);
        void message.success('cardholder updated successfully');
        dispatch(setEditedNodeDetails<any>({ type: 'cardholder', values: finalObj }));
        dispatch(setOpencarholdereditModal<any>(false));
      } catch (error) {
        return error;
      }
    } else {
      dispatch(setEditedNodeDetails<any>({ type: 'cardholder', values: finalObj }));
      dispatch(setOpencarholdereditModal<any>(false));
    }
    setIsSASloading(false);
    return finalObj;
  }

  async function sendInvitation() {
    setIsSendInvitationBtnLoadin(true);
    const editedObj = await form.validateFields();
    try {
      const finalObj = { ...cardholderInitialValues, ...editedObj };
      const sendInvitaionBody = {
        lastName: finalObj.lastName,
        firstName: finalObj.firstName,
        email: finalObj.email,
        phoneNumber: finalObj.mobile,
      };
      const invitationSent = await sendInvitaion.mutateAsync(sendInvitaionBody);
      const sendInvitationCounter = form.getFieldValue(['sendInvitationCounter']);
      dispatch(
        setEditedNodeDetails<any>({
          type: 'cardholder',
          values: { ...finalObj, sendInvitationCounter: Number(sendInvitationCounter) + 1 },
        }),
      );
      void message.success('Invitation sent successfully');
      dispatch(setOpencarholdereditModal<any>(false));
    } catch (error) {
      console.error('Form validation failed:', error);
    }
    setIsSendInvitationBtnLoadin(false);
  }
  const checkifEmailDisabled = cardholderInitialValues?.sendInvitationCounter > 4;

  if (sales && isItPhysical) {
    return (
      <FormDrawer
        id="cardHolderDrawer"
        open={open}
        onClose={onClose}
        title={t('Add new Cardholder')}
        formName={formName}
      >
        <CardHolderDetails
          onFinish={(value: any) => saveHandler(value)}
          initialValues={cardholderInitialValues}
          cardHolderType={productKey}
        />
      </FormDrawer>
    );
  }

  return (
    <Modal
      title={
        <Typography.Title style={{ fontSize: 38, marginBottom: 10 }} level={1}>
          {isItPhysical ? 'Edit Card Details & Send Invitation' : 'Edit Card Details '}
        </Typography.Title>
      }
      centered
      visible={isModalOpen && !sales}
      footer={null}
      okText="Save"
      width={900}
    >
      <Container>
        <Form
          onFinish={() => saveHandler()}
          initialValues={cardholderInitialValues?.cardHolderValues}
          form={form}
          name="cardholder-control-edit"
        >
          <Typography.Title style={{ marginBottom: '20px' }} level={5}>
            {t('PERSONAL DETAILS')}{' '}
          </Typography.Title>
          {!isItPhysical && (
            <>
              <Row gutter={0}>
                <Col span={12}>
                  <Form.Item
                    rules={[
                      { required: true },
                      {
                        message: 'The name of the card should be two words',
                        validator: (_, value) => {
                          if (/\b[a-zA-Z]+\s[a-zA-Z]+\b/.test(value)) {
                            if (value.split(' ').length > 2) {
                              return Promise.reject();
                            }
                            return Promise.resolve();
                          }
                          return Promise.reject();
                        },
                      },
                      {
                        message: 'Exceed Maximum Length',
                        validator: (_, value) => {
                          if (value?.length > 21) {
                            return Promise.reject();
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    name="nameOfVirtualCardAccount"
                  >
                    <FloatLabel label={capitalizeWords(t('Name of virtual card account'))}>
                      <Input maxLength={21} />
                    </FloatLabel>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <CustomTooltip text={t('The name of the card should be two words')} width={250} />
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }}>
                <Col span={12}>
                  <Form.Item
                    rules={[
                      { required: true },
                      {
                        message: <p>alphabetic characters only allowed</p>,
                        validator: (_, value) => {
                          if (!/^[a-zA-Z\s]*$/g.test(value)) {
                            return Promise.reject();
                          }
                          return Promise.resolve();
                        },
                      },
                      {
                        message: 'Maximum 21 characters allowed',
                        validator: (_, value) => {
                          if (value?.length > 21) {
                            return Promise.reject();
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    name="companyEmbossing"
                  >
                    <FloatLabel label={t('companyEmbossing')}>
                      <Input maxLength={21} />
                    </FloatLabel>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <CustomTooltip text={t('Maximum 21 characters allowed')} width={250} />
                </Col>
              </Row>
            </>
          )}
          {isItPhysical && (
            <>
              <Row gutter={30}>
                <Col span={12}>
                  <Form.Item
                    rules={[
                      { required: true, message: <p style={{ paddingBottom: '8px' }}> Required</p> },
                      {
                        message: <p style={{ paddingBottom: '8px' }}> The first name should not contain number(s)</p>,
                        validator: (_, value) => {
                          if (/\d/.test(value)) {
                            return Promise.reject();
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    name="firstName"
                  >
                    <FloatLabel label={capitalizeWords(t('firstName'))}>
                      <Input />
                    </FloatLabel>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    rules={[
                      { required: true, message: <p style={{ paddingBottom: '8px' }}> Required</p> },
                      {
                        message: <p style={{ paddingBottom: '8px' }}> The last name should not contain number(s)</p>,
                        validator: (_, value) => {
                          if (/\d/.test(value)) {
                            return Promise.reject();
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    name="lastName"
                  >
                    <FloatLabel label={t('lastName')}>
                      <Input />
                    </FloatLabel>
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ paddingBottom: '8px' }} gutter={30}>
                <Col span={12}>
                  <div
                    style={
                      checkifEmailDisabled
                        ? {
                            paddingBottom: '40px',
                            // height:"80px",
                            borderStyle: 'solid',
                            borderWidth: '2px',
                            borderColor: '#FFF7E6',
                            marginBottom: '30px',
                            borderRadius: '8px',
                          }
                        : {}
                    }
                  >
                    <div>
                      <Form.Item
                        style={{ padding: 0 }}
                        rules={[
                          { required: true },
                          { type: 'email' },
                          { validator: emailDuplicateCheck(form.getFieldValue('contactId'), 'cardholder') },
                        ]}
                        name="email"
                      >
                        <FloatLabel label={t('email')}>
                          <Input disabled={cardholderInitialValues?.sendInvitationCounter > 4} />
                        </FloatLabel>
                      </Form.Item>
                      {checkifEmailDisabled && (
                        <Alert
                          style={{ position: 'absolute', top: '54px', width: '92%' }}
                          message="You have reached the maximum number of send invitation trials"
                          type="warning"
                          showIcon
                        />
                      )}
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <PhoneNumberFormItem
                    name="mobile"
                    rules={[
                      { required: true },
                      {
                        validator: phoneValidation(),
                      },
                    ]}
                  />
                </Col>
              </Row>
              <Row gutter={30}>
                <Col span={12}>
                  <Form.Item name="designation">
                    <FloatLabel label={t('Designation')}>
                      <Input />
                    </FloatLabel>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <Form.Item style={{ display: 'none' }} name="sendInvitationCounter">
            <InputNumber />
          </Form.Item>
          <Row style={{ alignItems: 'center', display: isItPhysical ? undefined : 'none' }}>
            <Col style={{ marginRight: '20px' }}>
              <Form.Item
                rules={
                  isItPhysical
                    ? [
                        {
                          message: (
                            <div style={{ marginBottom: 60 }}>
                              {' '}
                              <p style={{ position: 'absolute', bottom: 0 }}> required</p>
                            </div>
                          ),
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject();
                            }
                            return Promise.resolve();
                          },
                        },
                      ]
                    : undefined
                }
                valuePropName="checked"
                name="hasConsent"
              >
                <Checkbox />
              </Form.Item>
            </Col>
            <Col style={{ width: '80%' }}>
              <Typography.Paragraph>
                {t(
                  'Customer confirm that has the consent from the above proposed cardholder to share their information with us',
                )}
              </Typography.Paragraph>
            </Col>
          </Row>
          <Row justify="center" gutter={20}>
            <Col>
              {isItPhysical && (
                <Button
                  loading={isSendInvitationBtnLoadin}
                  className="footerBtn"
                  id="SendBtn"
                  type="primary"
                  onClick={() => sendInvitation()}
                >
                  {t('Send Invitation')}
                </Button>
              )}
            </Col>
            <Col>
              <Button loading={isSASloading} htmlType="submit" id="Save$send" type="primary" className="footerBtn">
                {t('Save')}
              </Button>
            </Col>

            <Col>
              <Button onClick={() => dispatch(setOpencarholdereditModal<any>(false))} id="cancel" className="footerBtn">
                {t('Cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </Modal>
  );
}

const Container = styled.div<any>`
  .footerBtn {
    /* display: flex; */
    width: 218px;
    height: 44.844px;
    padding: 8px 16px;
    /* flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0; */
  }
  .supplyerTypesSection {
    position: relative;
    display: flex;
    padding: 9px 12px;
    padding-top: 16px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid var(--alert-orange-2, #ffe58f);
    background: var(--alert-orange-3, #fffbe6);
  }
`;
export default CardHolderEditModal;
